import { render, staticRenderFns } from "./PreviewPDF.vue?vue&type=template&id=23bfa13c&scoped=true"
import script from "./PreviewPDF.vue?vue&type=script&lang=js"
export * from "./PreviewPDF.vue?vue&type=script&lang=js"
import style0 from "./PreviewPDF.vue?vue&type=style&index=0&id=23bfa13c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfa13c",
  null
  
)

export default component.exports